import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, Subscription } from 'rxjs';
import { ApiServiceListService } from 'src/app/_services/api/api-service-list.service';
import { CommonService } from 'src/app/_services/common/common.service';
import { LoginRoles, PhoneNumbCheckStatus } from 'src/app/model/common.model';
import { IRetailer } from 'src/app/model/retailer.model';
import { AuthServiceUser } from 'src/app/services/auth/auth.service';
import { PhoneUserValidationService } from 'src/app/services/phone-user-validation/phone-user-validation.service';

@Component({
    selector: 'app-add-retailer',
    templateUrl: './add-retailer.component.html',
    styleUrl: './add-retailer.component.css',
    standalone: false
})
export class AddRetailerComponent {

  private phoneValidationService = inject(PhoneUserValidationService);
  protected cmnService = inject(CommonService);
  showLoader = false;
  breadcrumb = {
    'mainlabel': 'Retailer Management',
  };
  zoneList: any = [];
  retailerList: any = [];
  mainRetailerIdSelect: string = '';
  selectedMainRetailer: any;
  mapCoordinates: any = {};
  dropdownSettingsZone = {
    singleSelection: true,
    idField: '_id',
    textField: 'name',
    enableCheckAll: false,
    itemsShowLimit: 10,
    allowSearchFilter: true,
    closeDropDownOnSelection: true
  };

  phoneValidationClass = '';
  phoneNumbCheckStatus = PhoneNumbCheckStatus;

  selectedMapDrawing: any;
  private routeSub: Subscription;
  isEditPage: boolean = false;
  currentId: string;
  currentSelectedLocation: any;
  selectedZone: any;

  currentDrawing = [];

  isZoneAdmin: boolean = false;
  loginUserDetails: any;

  // currentDrawing = [
  //   {
  //     type: 'Polygon',
  //     coordinates: [
  //       [14.563618, 78.8042718],
  //       [14.583628, 78.8342718],
  //       [14.563638, 78.8242718],
  //     ],
  //   },
  //   {
  //     type: 'Circle',
  //     circle: {
  //       center: [14.666668, 78.8062718],
  //       radius: 800,
  //     },
  //   },
  // ];

  model: any = {
    name: '',
    zone: '',
    user: {
      name: '',
      phone: null,
      email: '',
      role: 'retailer',
    },
    address: {
      addressHeader: '',
      addressText: '',
      latLng: '',
      zipcode: '',
      state: '',
    },
    mapType: 'Circle',
    type: '',
    reatilerSelect: {},
    retailerEmployees: [{
      "name": "",
      "phone": "",
      "email": "",
      "role": "retailerEmployee",
      "phoneValidationClass": ""
    }],
    cartConfig: {
      groceryMinLeadHours: 0,
      packageMinLeadHours: 2,
      serviceMinLeadHours: 0,
      groceryMaxScheduleDays: 45,
      packageMaxScheduleDays: 45,
      serviceMaxScheduleDays: 45,
      serviceRequireNextDay: true,
      serviceScheduleStartTime: '09:00',
      serviceScheduleEndTime: '22:00',
      serviceSlotIntervalMinutes: 30,
    },
    retailCounterEnabled: true,
    status: true,
  };

  constructor(private route: ActivatedRoute, private authServiceUser: AuthServiceUser, private router: Router, private readonly changeDetector: ChangeDetectorRef, private apiService: ApiServiceListService, private toastr: ToastrService,) { }

  mapDrawingMode: google.maps.drawing.OverlayType.CIRCLE | google.maps.drawing.OverlayType.POLYGON;

  ngOnInit() {

    this.routeSub = this.route.params.subscribe(params => {
      // console.log(params) //log the entire params object
      // console.log(params['id']) //log the value of id
      if (params != undefined && params['id'] != undefined) {
        this.isEditPage = true
        this.getRetailerById(params['id']);
      } else {
        this.isEditPage = false;
        this.getZonesList();
      }
    });

    this.loginUserDetails = this.authServiceUser.getUserInfo();
    this.isZoneAdmin = this.loginUserDetails.role.includes(LoginRoles.ZONEADMIN);

  }

  getZonesList() {
    this.apiService.getZonesList().subscribe(
      {
        next: (response: any) => {
          this.appendZoneData(response);
        },
        error: (err) => {
          console.log(err);
        }
      }
    );
  }

  appendZoneData(zoneResponse) {
    {
      this.zoneList = zoneResponse.data;
      if (this.isZoneAdmin) {
        let zoneId = this.loginUserDetails.zone._id;
        this.zoneChange({ _id: zoneId });
      }
    }
  }

  getRetailerByZone(zoneId) {
    let payload = {
      zone: zoneId,
      type: 'grocery'
    }
    this.apiService.getRetailerByZoneData(payload).subscribe(
      {
        next: (response: any) => {
          if (response.data) {
            this.retailerList = response.data;
            this.model.reatilerSelect = this.retailerList.find(x => x._id === this.mainRetailerIdSelect);
            if (this.model.reatilerSelect) {
              let convertedObj = this.convertDrawingFormat(this.model.reatilerSelect.serviceArea);
              this.selectedMapDrawing = convertedObj.currentDrawing[0];
            }
          }
        },
        error: (err) => {
          console.log(err);
        }
      }
    );
  }


  onSelectItem(event: any, row: any) {
    // row.mainRetailer = event._id; // Update row.name with the selected value
    this.model.reatilerSelect = event;

    if (event) {
      let convertedObj = this.convertDrawingFormat(this.model.reatilerSelect.serviceArea);
      this.selectedMapDrawing = convertedObj.currentDrawing[0];
    } else {
      this.selectedMapDrawing = null;
    }
  }


  zoneChange(event) {
    // this.getRetailerByZone(event._id);
    this.selectedZone = this.zoneList.find(x => x._id === event._id);
    if (event) {
      let convertedObj = this.convertDrawingFormat(this.selectedZone.area);
      this.selectedMapDrawing = convertedObj.currentDrawing[0];
    } else {
      this.selectedMapDrawing = null;
    }
  }

  getCoverEntireArea() {
    if (this.selectedZone.area) {
      const convertedObj = this.convertDrawingFormat(this.selectedZone.area);
      this.currentDrawing = convertedObj.currentDrawing;
      this.mapDrawingMode = convertedObj.mapDrawingMode;
      this.model.mapType = convertedObj.mapType;
    }

  }

  addEmployee() {
    this.model.retailerEmployees.push({
      name: '',
      phone: '',
      email: '',
      phoneValidationClass: '',
    });
  }

  deleteEmployee(index: number) {
    if (index >= 0 && index < this.model.retailerEmployees.length) {
      this.model.retailerEmployees.splice(index, 1);
    }
  }


  // forkJoin([filterInfo$, getTableData$]).subscribe(
  //       {
  //         next: ([filterInfo, tableData]) => {

  getRetailerById(id: string) {
    const getRetailerData$ = this.apiService.getRetailerById(id);
    const getZoneList$ = this.apiService.getZonesList();

    forkJoin([getZoneList$, getRetailerData$])
      .subscribe({
        next: ([zoneResponse, response]) => {
          // response.data.status = this.cmnService.getStatusRetrunValue(response.data.status);
          if (zoneResponse.success) {
            this.appendZoneData(zoneResponse);
          }
          this.model = { ...response.data };
          this.model.retailCounterEnabled = response?.data?.retailCounterEnabled !== false;
          this.model.cartConfig = this.normalizeCartConfigForUI(
            response.data.cartConfig || {},
            response.data.type,
          );
          this.model.zone = [];
          if (response.data.zone) {
            const element = response.data.zone;
            this.model.zone.push({ _id: element._id, name: element.name });
            // if (this.model.type === 'kitchen') {
            //   this.getRetailerByZone(element._id);
            // }
            this.zoneChange({ _id: element._id });
          }
          this.model.status = this.cmnService.getStatusRetrunValue(this.model.status);
          this.currentId = response.data._id;
          if (response.data.serviceArea) {
            const serviceArea = response.data.serviceArea;
            // this.currentDrawing = [];
            let convertedObj = this.convertDrawingFormat(serviceArea);
            this.currentDrawing = convertedObj.currentDrawing;
            this.mapDrawingMode = convertedObj.mapDrawingMode;
            this.model.mapType = convertedObj.mapType;
          }

          if (!this.model.retailerEmployees) {
            this.model.retailerEmployees = [];
          }
          this.mainRetailerIdSelect = this.model.mainRetailer;
          this.currentSelectedLocation = { lat: response.data.location.coordinates[0], lng: response.data.location.coordinates[1] };
          console.log(this.model);
        },
        error: (err) => {
          console.log(err);
        },
        complete: () => {
          console.log("completed");

        }
      });

  }

  convertDrawingFormat(serviceArea) {
    let mapDrawingMode: any;
    const currentDrawing = [];
    let mapType = '';
    if (serviceArea.circle.center && serviceArea.circle.center.length !== 0) {
      mapType = "Circle";
      mapDrawingMode = google.maps.drawing.OverlayType.CIRCLE;
      currentDrawing.push({ type: 'Circle', circle: serviceArea.circle });
    }

    if (serviceArea.polygon.coordinates && serviceArea.polygon.coordinates.length !== 0) {
      mapType = "Polygon";
      currentDrawing.push({ type: 'Polygon', polygon: serviceArea.polygon });
      mapDrawingMode = google.maps.drawing.OverlayType.POLYGON;
    }

    return { mapType, currentDrawing, mapDrawingMode };
  }

  currentMarkerAddress(event) {
    this.model = {
      ...this.model,
      address: {
        ...this.model.address,
        addressHeader: event.addressHeader,
        addressText: event.addressText,
        latLng: event.latLng,
        zipcode: event.zipcode,
        state: event.state,
      },
    };
    console.log(this.model);
    this.changeDetector.markForCheck();
  }

  currentPathCoordinates(event) {
    this.mapCoordinates = event;
    console.log(this.mapCoordinates);
  }

  addRetailer(isFormValid) {

    if (this.phoneValidationClass === PhoneNumbCheckStatus.ERROR) {
      this.toastr.error("Please check phone number", '', {
        timeOut: 3000,
      });
      return;
    }
    if (isFormValid) {
      const body: IRetailer = {} as IRetailer;
      body.name = this.model.name;
      body.zone = this.model.zone[0]._id;
      body.user = this.model.user;
      body.address = this.model.address;
      body.serviceArea = this.mapCoordinates;
      // body.address.zone = this.model.zone[0]._id;
      body.address.defaultAddress = false;
      body.type = this.model.type;
      body.retailerEmployees = this.model.retailerEmployees;
      body.cartConfig = this.buildCartConfigPayload(this.model.cartConfig || {}, this.model.type);
      body.retailCounterEnabled = this.model?.retailCounterEnabled !== false;

      if (typeof this.model.status === 'boolean') {
        body.status = this.cmnService.getStatusValue(this.model.status);
      } else {
        body.status = this.model.status;
      }

      if (this.model.type === 'kitchen') {
        body.mainRetailer = this.model.reatilerSelect?._id;
      } else {
        body.mainRetailer = null;
      }

      if (!this.mapCoordinates || Object.keys(this.mapCoordinates).length === 0) {
        this.toastr.error("Please select retailer zone", '', {
          timeOut: 3000,
        });
        return;
      }


      this.showLoader = true;
      body.retailerEmployees = body.retailerEmployees.map(x => {
        if (!x._id) {
          delete x._id;
        }
        return x;
      })
      if (this.isEditPage) {
        body._id = this.currentId;
        delete body.user._id;

        this.apiService.updateRetailerAPI(body).subscribe({
          next: (response) => {

            this.toastr.success(response.message, '', {
              timeOut: 3000,
            });
            this.router.navigateByUrl('/retailer/all');
            this.showLoader = false;
          },
          error: (err) => {
            console.log(err);
            this.toastr.error(err.message, '', {
              timeOut: 3000,
            });
            this.showLoader = false;
          }
        })
      } else {
        if (!body.user._id) {
          delete body.user._id;
        }

        this.apiService.addRetailerDetailsAPI(body).subscribe({
          next: (response) => {

            this.toastr.success(response.message, '', {
              timeOut: 3000,
            });
            this.router.navigateByUrl('/retailer/all');
            this.showLoader = false;
          },
          error: (err) => {
            console.log(err);
            this.toastr.error(err.message, '', {
              timeOut: 3000,
            });
            this.showLoader = false;
          }
        })
      }
    } else {
      console.log('Form is invalid');

    }
  }

  validateUserPhoneNum(phoneNum: string, userRole: string, item?: any): void {
    if (!phoneNum || phoneNum.length < 10) {
      if (item) {
        item.phoneValidationClass = PhoneNumbCheckStatus.ERROR;
        item._id = "";
      } else {
        this.phoneValidationClass = PhoneNumbCheckStatus.ERROR;
        this.model.user._id = "";
      }
      return;
    }

    if (phoneNum && phoneNum.length > 10) {
      this.model.user.phone = phoneNum.slice(0, 10); // Update model to first 10 digits
      return;
    }

    if (item) {
      item.phoneValidationClass = PhoneNumbCheckStatus.LOADING;
    } else {
      this.phoneValidationClass = PhoneNumbCheckStatus.LOADING;
    }
    this.phoneValidationService.validatePhoneNumber(phoneNum, userRole).subscribe({
      next: (result) => {
        if (item) {
          item.phoneValidationClass = result.status;
          if (result.user) {
            if (result.user.name) {
              item.name = result.user.name;
            }
            if (result.user.email) {
              item.email = result.user.email;
            }
            item._id = result.user.id;
          }
        } else {
          this.phoneValidationClass = result.status;
          if (result.user) {
            if (result.user.name) {
              this.model.user.name = result.user.name;
            }
            if (result.user.email) {
              this.model.user.email = result.user.email;
            }
            this.model.user._id = result.user.id;
          }
        }
      },
      error: () => {
        this.phoneValidationClass = PhoneNumbCheckStatus.ERROR;
      },
    });
  }

  navigateTOList() {
    this.router.navigateByUrl('/retailer/all');
  }

  mapSelctionChange(event) {
    if (event.target.value === 'Circle') {
      this.mapDrawingMode = google.maps.drawing.OverlayType.CIRCLE;
    } else {
      this.mapDrawingMode = google.maps.drawing.OverlayType.POLYGON;
    }
  }

  isGroceryRetailerType(): boolean {
    return String(this.model?.type || '').toLowerCase() === 'grocery';
  }

  isKitchenRetailerType(): boolean {
    return String(this.model?.type || '').toLowerCase() === 'kitchen';
  }

  onRetailerTypeChange(): void {
    this.model.cartConfig = this.normalizeCartConfigForUI(
      this.model?.cartConfig || {},
      this.model?.type,
    );
  }

  private toNumber(value: any, fallback = 0): number {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  private toNonNegative(value: any, fallback = 0): number {
    const parsed = this.toNumber(value, fallback);
    return parsed >= 0 ? parsed : fallback;
  }

  private normalizeTime(value: any, fallback: string): string {
    if (typeof value !== 'string' || !value.trim()) {
      return fallback;
    }
    const match = value.trim().match(/^(\d{1,2}):(\d{2})$/);
    if (!match) return fallback;

    const hour = Number(match[1]);
    const minute = Number(match[2]);
    if (!Number.isFinite(hour) || !Number.isFinite(minute)) return fallback;
    if (hour < 0 || hour > 23 || minute < 0 || minute > 59) return fallback;
    return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
  }

  private normalizeInterval(value: any, fallback = 30): number {
    const parsed = Math.round(this.toNonNegative(value, fallback));
    if (!parsed || parsed % 30 !== 0) {
      return fallback;
    }
    return parsed;
  }

  private normalizeMaxScheduleDays(value: any, fallback = 45): number {
    const parsed = Math.round(this.toNonNegative(value, fallback));
    if (!parsed) {
      return fallback;
    }
    return parsed;
  }

  private normalizeRetailerType(retailerType?: string): 'grocery' | 'kitchen' {
    return String(retailerType || '').toLowerCase() === 'kitchen' ? 'kitchen' : 'grocery';
  }

  private getDefaultCartConfig(retailerType?: string) {
    const normalizedType = this.normalizeRetailerType(retailerType);
    if (normalizedType === 'kitchen') {
      return {
        kitchenMinLeadHours: 0,
        kitchenMaxScheduleDays: 45,
        kitchenRequireNextDay: true,
        kitchenScheduleStartTime: '09:00',
        kitchenScheduleEndTime: '22:00',
        kitchenSlotIntervalMinutes: 30,
      };
    }
    return {
      groceryMinLeadHours: 0,
      packageMinLeadHours: 2,
      serviceMinLeadHours: 0,
      groceryMaxScheduleDays: 45,
      packageMaxScheduleDays: 45,
      serviceMaxScheduleDays: 45,
      serviceRequireNextDay: true,
      serviceScheduleStartTime: '09:00',
      serviceScheduleEndTime: '22:00',
      serviceSlotIntervalMinutes: 30,
    };
  }

  private normalizeCartConfigForUI(cartConfig: any = {}, retailerType?: string) {
    const normalizedType = this.normalizeRetailerType(retailerType || this.model?.type);
    const defaults = this.getDefaultCartConfig(normalizedType);

    if (normalizedType === 'kitchen') {
      const kitchenMinLeadHours =
        cartConfig.kitchenMinLeadHours ??
        (this.toNonNegative(cartConfig.kitchenMinLeadMinutes, defaults.kitchenMinLeadHours * 60) / 60);
      return {
        ...defaults,
        kitchenMinLeadHours: this.toNonNegative(kitchenMinLeadHours, defaults.kitchenMinLeadHours),
        kitchenMaxScheduleDays: this.normalizeMaxScheduleDays(
          cartConfig.kitchenMaxScheduleDays,
          defaults.kitchenMaxScheduleDays,
        ),
        kitchenRequireNextDay:
          typeof cartConfig.kitchenRequireNextDay === 'boolean'
            ? cartConfig.kitchenRequireNextDay
            : defaults.kitchenRequireNextDay,
        kitchenScheduleStartTime: this.normalizeTime(
          cartConfig.kitchenScheduleStartTime,
          defaults.kitchenScheduleStartTime,
        ),
        kitchenScheduleEndTime: this.normalizeTime(
          cartConfig.kitchenScheduleEndTime,
          defaults.kitchenScheduleEndTime,
        ),
        kitchenSlotIntervalMinutes: this.normalizeInterval(
          cartConfig.kitchenSlotIntervalMinutes,
          defaults.kitchenSlotIntervalMinutes,
        ),
      };
    }

    const groceryMinLeadHours =
      cartConfig.groceryMinLeadHours ??
      (this.toNonNegative(cartConfig.groceryMinLeadMinutes, defaults.groceryMinLeadHours * 60) / 60);
    const packageMinLeadHours =
      cartConfig.packageMinLeadHours ??
      (this.toNonNegative(cartConfig.packageMinLeadMinutes, defaults.packageMinLeadHours * 60) / 60);
    const serviceMinLeadHours =
      cartConfig.serviceMinLeadHours ??
      (this.toNonNegative(cartConfig.serviceMinLeadMinutes, defaults.serviceMinLeadHours * 60) / 60);

    return {
      ...defaults,
      groceryMinLeadHours: this.toNonNegative(groceryMinLeadHours, defaults.groceryMinLeadHours),
      packageMinLeadHours: this.toNonNegative(packageMinLeadHours, defaults.packageMinLeadHours),
      serviceMinLeadHours: this.toNonNegative(serviceMinLeadHours, defaults.serviceMinLeadHours),
      groceryMaxScheduleDays: this.normalizeMaxScheduleDays(
        cartConfig.groceryMaxScheduleDays,
        defaults.groceryMaxScheduleDays,
      ),
      packageMaxScheduleDays: this.normalizeMaxScheduleDays(
        cartConfig.packageMaxScheduleDays,
        defaults.packageMaxScheduleDays,
      ),
      serviceMaxScheduleDays: this.normalizeMaxScheduleDays(
        cartConfig.serviceMaxScheduleDays,
        defaults.serviceMaxScheduleDays,
      ),
      serviceRequireNextDay:
        typeof cartConfig.serviceRequireNextDay === 'boolean'
          ? cartConfig.serviceRequireNextDay
          : defaults.serviceRequireNextDay,
      serviceScheduleStartTime: this.normalizeTime(
        cartConfig.serviceScheduleStartTime,
        defaults.serviceScheduleStartTime,
      ),
      serviceScheduleEndTime: this.normalizeTime(
        cartConfig.serviceScheduleEndTime,
        defaults.serviceScheduleEndTime,
      ),
      serviceSlotIntervalMinutes: this.normalizeInterval(
        cartConfig.serviceSlotIntervalMinutes,
        defaults.serviceSlotIntervalMinutes,
      ),
    };
  }

  private buildCartConfigPayload(cartConfig: any = {}, retailerType?: string) {
    const normalizedType = this.normalizeRetailerType(retailerType || this.model?.type);
    const normalized = this.normalizeCartConfigForUI(cartConfig, normalizedType);

    if (normalizedType === 'kitchen') {
      return {
        kitchenMinLeadHours: normalized.kitchenMinLeadHours,
        kitchenMaxScheduleDays: normalized.kitchenMaxScheduleDays,
        kitchenRequireNextDay: normalized.kitchenRequireNextDay,
        kitchenScheduleStartTime: normalized.kitchenScheduleStartTime,
        kitchenScheduleEndTime: normalized.kitchenScheduleEndTime,
        kitchenSlotIntervalMinutes: normalized.kitchenSlotIntervalMinutes,
      };
    }

    return {
      groceryMinLeadHours: normalized.groceryMinLeadHours,
      packageMinLeadHours: normalized.packageMinLeadHours,
      serviceMinLeadHours: normalized.serviceMinLeadHours,
      groceryMaxScheduleDays: normalized.groceryMaxScheduleDays,
      packageMaxScheduleDays: normalized.packageMaxScheduleDays,
      serviceMaxScheduleDays: normalized.serviceMaxScheduleDays,
      serviceRequireNextDay: normalized.serviceRequireNextDay,
      serviceScheduleStartTime: normalized.serviceScheduleStartTime,
      serviceScheduleEndTime: normalized.serviceScheduleEndTime,
      serviceSlotIntervalMinutes: normalized.serviceSlotIntervalMinutes,
    };
  }
}
